import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Placeholder from 'components/consumer/Placeholder';
const PDPShopTabsBarPlaceholder = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Placeholder type="rect" loading={true} className="!w-full !h-[58px]" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default PDPShopTabsBarPlaceholder;